import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
export function Lightbox({
  src,
  alt,
  onClose
}: {
  src: string;
  alt: string;
  onClose: () => void;
}) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);
  return <motion.div role="dialog" aria-modal="true" aria-label={alt} initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} transition={{
    duration: 0.18,
    ease: [0.23, 1, 0.32, 1]
  }} onClick={onClose} className="fixed inset-0 z-[60] flex items-center justify-center bg-ink/90 p-5 backdrop-blur-sm" data-id="element-421" data-mp="v32svhpcf0fo">
      <motion.img initial={{
      opacity: 0,
      scale: 0.96
    }} animate={{
      opacity: 1,
      scale: 1
    }} exit={{
      opacity: 0,
      scale: 0.96
    }} transition={{
      duration: 0.2,
      ease: [0.23, 1, 0.32, 1]
    }} src={src} alt={alt} onClick={e => e.stopPropagation()} className="max-h-[85vh] w-auto rounded-2xl border border-line object-contain" data-id="element-422" data-mp="cb0hakrk6aca" />
      <button type="button" onClick={onClose} aria-label="Cerrar" className="absolute right-5 top-5 grid h-11 w-11 place-items-center rounded-xl border border-line bg-surface2/80 text-white" data-id="element-423" data-mp="1xfutvphigymx">
        <XIcon className="h-5 w-5" data-id="element-424" data-mp="15pgjw4cmc6gj" />
      </button>
    </motion.div>;
}